import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";
import { useAuth } from "../auth";

/** Menu account condiviso: flottante (sticky) sotto la navbar, presente sia in
 * /account sia in /sims, così dalla Console SIM non si perde mai il menu cliente. */
export default function AccountTabs({ active }) {
  const { t } = useLanguage();
  const { user } = useAuth();
  const TABS = [
    ["esims", "/account", t("acc.tabEsims")],
    ["console", "/sims", t("console.title")],
    ["wallet", "/account?tab=wallet", t("wallet.tab")],
    ["referral", "/account?tab=referral", t("ref.tab")],
    ["account", "/account?tab=account", t("acc.tabManage")],
    ["security", "/account?tab=security", t("acc.tabSecurity")],
  ];
  if (user?.is_dealer || user?.api_enabled) TABS.splice(4, 0, ["api", "/account?tab=api", "API"]);
  return (
    <div data-testid="account-tabs"
      className="sticky top-[64px] z-30 -mx-4 sm:-mx-6 px-4 sm:px-6 py-2.5 mb-6 bg-[#FBF9F5]/90 backdrop-blur-xl border-b border-[var(--border-subtle)]">
      <div className="flex gap-2 overflow-x-auto sm:flex-wrap sm:overflow-visible pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {TABS.map(([k, to, label]) => (
          <Link key={k} to={to} data-testid={`account-tab-${k}`}
            className={`shrink-0 rounded-full px-4 sm:px-5 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-widest whitespace-nowrap transition-colors outline-none focus-visible:ring-2 focus-visible:ring-[#FF6B35]/60 ${active === k ? "bg-[#1E293B] text-white" : "bg-white border border-slate-200 text-slate-500 hover:border-[#FF6B35] hover:text-[#FF6B35]"}`}>
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}
